import { render, staticRenderFns } from "./NuevoEntrega.vue?vue&type=template&id=df83153a&scoped=true"
import script from "./NuevoEntrega.vue?vue&type=script&lang=js"
export * from "./NuevoEntrega.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "spinkit/spinkit.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./NuevoEntrega.vue?vue&type=style&index=2&id=df83153a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df83153a",
  null
  
)

export default component.exports